import request from "@/utils/request";

export function apiListClue(params) {
  return request.get("/clue/list", params);
}

export function apiClueSummary(params) {
  return request.get("/clue/summary", params);
}

export function apiDetailClue(params) {
  return request.get("/clue/detail", params);
}

export function apiEditClue(params) {
  return request.post("/clue/edit", params);
}

export function apiDeleteClue(params) {
  return request.post("/clue/delete", params);
}

export function apiManualForwardClue(params) {
  return request.post("/clue/manualForward", params);
}

export function apiClueDeliveryLogList(params) {
  return request.get("/clueDeliveryLog/list", params);
}
